export type ModuleEvent = {
  action: string;
  at: string;
  interactionId?: string;
  data?: any;
};

export type AnalyticsEvent = ModuleEvent & {
  projectId: string;
  accountId: string;
  versionId: string;
  userId?: string;
  sessionId: string;
  source: string;
};

export function startModuleEvent(): ModuleEvent {
  //

  return {
    action: 'start_module',
    at: new Date().toISOString(),
  };
}

export function blurEvent(): ModuleEvent {
  return {
    action: 'blur_module',
    at: new Date().toISOString(),
  };
}

export function focusEvent(): ModuleEvent {
  //

  return {
    action: 'focus_module',
    at: new Date().toISOString(),
  };
}

export function completeModuleEvent(): ModuleEvent {
  return {
    action: 'complete_module',
    at: new Date().toISOString(),
  };
}

export function exitModuleEvent(event: { duration: number }): ModuleEvent {
  return {
    action: 'exit_module',
    at: new Date().toISOString(),
    data: event,
  };
}

type progressEventData = { progress: number };

export function progressEvent(event: progressEventData): ModuleEvent {
  //

  return {
    action: 'progress',
    data: event,
    at: new Date().toISOString(),
  };
}

type scoreEventData = {
  score: number;
  maxScore: number;
  percent: number;
  passMark: number;
};
export function scoreEvent(event: scoreEventData): ModuleEvent {
  return {
    action: 'score_change',
    data: event,
    at: new Date().toISOString(),
  };
}

export function enterInteractionEvent(interactionId: string): ModuleEvent {
  //

  return {
    action: 'enter_interaction',
    interactionId,
    at: new Date().toISOString(),
  };
}

export function leaveInteractionEvent(
  interactionId: string,
  duration: number
): ModuleEvent {
  //

  return {
    action: 'leave_interaction',
    interactionId,
    data: { duration },
    at: new Date().toISOString(),
  };
}

export function passFailEvent(event: { success: boolean }): ModuleEvent {
  return {
    action: 'pass_fail',
    data: event,
    at: new Date().toISOString(),
  };
}

type multichoiceEventData = {
  type: 'multi' | 'single';
  attemptNumber: number;
  response: string | string[];
  responseIds: string[];
  success: boolean;
};

export function multichoiceEvent(
  interactionId: string,
  event: multichoiceEventData
): ModuleEvent {
  //

  return {
    action: 'multichoice_attempt',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

type sortationEventData = {
  order: string[];
  attemptNumber: string;
  success: string;
};

export function sortationEvent(
  interactionId: string,
  event: sortationEventData
): ModuleEvent {
  return {
    action: 'sortation_attempt',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

type feedbackEventData = {
  interactionName: string;
  message: string;
  rating: string;
};

export function feedbackEvent(
  interactionId: string,
  event: feedbackEventData
): ModuleEvent {
  return {
    interactionId,
    action: 'feedback',
    data: event,
    at: new Date().toISOString(),
  };
}

type flipcardEventData = {
  flipcardId: string;
};

export function flipcardEvent(
  interactionId: string,
  event: flipcardEventData
): ModuleEvent {
  //

  return {
    action: 'flipcard_flip',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function videoPlayEvent(
  interactionId: string,
  event: {
    videoId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'video_play',
    interactionId,
    data: event,
    //
    at: new Date().toISOString(),
  };
}

export function videoSeekEvent(
  interactionId: string,
  event: {
    videoId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'video_seek',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function videoPauseEvent(
  interactionId: string,
  event: {
    videoId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'video_pause',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function videoFinishEvent(
  interactionId: string,
  event: {
    videoId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'video_finish',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function audioPlayEvent(
  interactionId: string,
  event: {
    audioId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'audio_play',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function audioSeekEvent(
  interactionId: string,
  event: {
    audioId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'audio_seek',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function audioPauseEvent(
  interactionId: string,
  event: {
    audioId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'audio_pause',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function audioFinishEvent(
  interactionId: string,
  event: {
    audioId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'audio_finish',
    interactionId,
    data: event,
    at: new Date().toISOString(),
  };
}

export function enterSlideEvent(
  interactionId: string,
  event: {
    slideId: string;
  }
): ModuleEvent {
  //

  return {
    action: 'enter_slide',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function exitSlideEvent(
  interactionId: string,
  event: {
    slideId: string;
    duration: number;
  }
): ModuleEvent {
  //

  return {
    action: 'exit_slide',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function accordionOpen(
  interactionId: string,
  event: {
    accordion_id: string;
  }
): ModuleEvent {
  //

  return {
    action: 'accordion_open',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function accordionClose(
  interactionId: string,
  event: {
    accordion_id: string;
    duration: number;
  }
): ModuleEvent {
  //

  return {
    action: 'accordion_close',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function clickRevealEvent(
  interactionId: string,
  event: {
    ctr_id: string;
  }
): ModuleEvent {
  //

  return {
    action: 'click_reveal',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function matchingDropEvent(
  interactionId: string,
  event: {
    matching_drop: {
      drag_id: string;
      drop_id: string;
      success: boolean;
    };
  }
): ModuleEvent {
  //

  return {
    action: 'matching_drop',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function matchingCompleteEvent(interactionId: string): ModuleEvent {
  //

  return {
    action: 'matching_complete',
    interactionId,
    at: new Date().toISOString(),
  };
}

type hotspotClickEventData = {
  hotspot_id: string;
};

export function hotspotEvent(
  interactionId: string,
  event: hotspotClickEventData
): ModuleEvent {
  //

  return {
    action: 'hotspot_click',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

type hotspotQuizEventData = {
  values: string | number | (string | number)[];
  responseIds: string[];
  type: string;
  success: boolean;
  attempt_number: number;
};

export function hotspotQuizEvent(
  interactionId: string,
  event: hotspotQuizEventData
): ModuleEvent {
  //

  return {
    action: 'hotspot_attempt',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function assessmentQuestionEvent(
  interactionId: string,
  event: {
    assessment_id: string;
    question_id: string;
    success: boolean;
    attemptNumber: number;
    responseIds: string[];
  }
): ModuleEvent {
  //

  return {
    action: 'assessment_question_attempt',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function assessmentCompleteEvent(
  assessmentId: string,
  event: {
    assessment_id: string;
    value: number;
    attemptNumber: number;
    success: boolean;
  }
): ModuleEvent {
  //

  return {
    action: 'assessment_complete',
    data: event,
    interactionId: assessmentId,
    at: new Date().toISOString(),
  };
}

export function pdfMaximiseEvent(
  interactionId: string,
  event: {}
): ModuleEvent {
  return {
    action: 'pdf_maximise',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function pdfMinimizeEvent(
  interactionId: string,
  event: {}
): ModuleEvent {
  return {
    action: 'pdf_maximise',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function sortationUserResponseEvent(
  //
  interactionId: string,
  event: {
    order: string | string[];
    success: boolean;
    attemptNumber: number;
  }
): ModuleEvent {
  //

  return {
    action: 'sortation_user_response',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function sliderSubmitEvent(
  interactionId: string,
  event: {
    value: number;
    success: boolean;
    attemptNumber: number;
  }
): ModuleEvent {
  //

  return {
    action: 'slider_submit',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function textEntryValueEvent(
  interactionId: string,
  event: {
    value: string;
  }
): ModuleEvent {
  //

  return {
    action: 'text_entry_value',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function textEntryResponseEvent(
  interactionId: string,
  event: {
    value: string;
    success: boolean;
    attemptNumber: number;
  }
): ModuleEvent {
  //

  return {
    action: 'text_entry_response',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function textEntryEvent(
  interactionId: string,
  event: {
    value: string;
    success: boolean;
    attemptNumber: number;
  }
): ModuleEvent {
  return {
    action: 'text_entry_submit',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function dropdownOptionResponseEvent(
  interactionId: string,
  event: {
    dropdown_id?: string;
    value: string;
    success: boolean;
    selectedIndex: number;
    attemptNumber: number;
  }
): ModuleEvent {
  //

  return {
    action: 'dropdown_option_response',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}

export function dropdownResponseEvent(
  interactionId: string,
  event: {
    success: boolean;
    attemptNumber: number;
  }
): ModuleEvent {
  return {
    action: 'dropdown_response',
    data: event,
    interactionId,
    at: new Date().toISOString(),
  };
}
